import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InvoiceViewService } from 'src/app/billing/invoice-view/invoice-view.service';
import { CommonBillingService } from 'src/app/billing/shared/common-billing.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-view-invoice',
  templateUrl: './view-invoice.component.html',
  styleUrls: ['./view-invoice.component.scss']
})
export class ViewInvoiceComponent implements OnInit {

  @Input() booking: any;

  @Output() closeCallback = new EventEmitter();
  @Output() showSuccessErrorAction = new EventEmitter();
  @Output() toggleLoadingOnViewInvoice = new EventEmitter();

  public invoiceImage = '';

  constructor(private invoiceViewService: InvoiceViewService, private commonBillingService: CommonBillingService,
              private authService: AuthService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.getInvoiceImage();
  }

  getInvoiceImage() {
    const queryParams = {
      bookingID: this.booking.bookingId,
      buid: this.authService.user.buId,
      empGuid: this.authService.user.employeeGuid,
    };
    this.invoiceViewService.fetchInvoiceImageBlob(queryParams).subscribe((response: any) => {
      const blob = new Blob([response.body], {type: 'jpeg'});
      const url = window.URL.createObjectURL(blob);
      this.invoiceImage = url;
      if (this.toggleLoadingOnViewInvoice) {
        this.toggleLoadingOnViewInvoice.emit(false);
      }
    });
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.invoiceImage);
  }

  closePopOver() {
    if (this.closeCallback) {
      this.closeCallback.emit();
    }
  }

  downloadInvoice() {
    const queryParams = {
      bookingID: this.booking.bookingId,
      buid: this.authService.user.buId,
      empGuid: this.authService.user.employeeGuid,
    };
    this.invoiceViewService.downloadInvoice(queryParams).subscribe((response: any) => {
      this.commonBillingService.downloadBlob(response);
    });
  }

  rejectInvoice() {
    const postData = [
      {
        approvalStatus: 'REJECTED',
        bookingID: this.booking.bookingId,
        modifierBuid: this.authService.user.buId,
        modifierGuid: this.authService.user.employeeGuid
      }
    ];
    if (this.toggleLoadingOnViewInvoice) {
      this.toggleLoadingOnViewInvoice.emit(true);
    }
    this.invoiceViewService.updateInvoiceStatus(postData).subscribe((response) => {
      if (this.showSuccessErrorAction) {
        this.showSuccessErrorAction.emit({actionSuccessful: true, message: 'Invoice Rejected Successfully'});
      }
    }, () => {
      if (this.showSuccessErrorAction) {
        this.showSuccessErrorAction.emit({actionSuccessful: false, message: 'Invoice Reject Failed'});
      }
    });
  }

  approveInvoice() {
    const postData = [
      {
        approvalStatus: 'APPROVED',
        bookingID: this.booking.bookingId,
        modifierBuid: this.authService.user.buId,
        modifierGuid: this.authService.user.employeeGuid
      }
    ];
    if (this.toggleLoadingOnViewInvoice) {
      this.toggleLoadingOnViewInvoice.emit(true);
    }
    this.invoiceViewService.updateInvoiceStatus(postData).subscribe((response) => {
      if (this.showSuccessErrorAction) {
        this.showSuccessErrorAction.emit({actionSuccessful: true, message: 'Invoice Approved Successfully'});
      }
    }, () => {
      if (this.showSuccessErrorAction) {
        this.showSuccessErrorAction.emit({actionSuccessful: false, message: 'Invoice Approve Failed'});
      }
    });
  }
}
